import React from 'react';
import ParametroCupomService from '../../../../lib/api/parametroCupom/parametroCupomService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class ParametroCupom extends React.Component<{},{}> 
{
    constructor(props: any)
    {
        super(props);
        this.state = {};
    }

    baixarExcelParametroCupom()
    {
        return ParametroCupomService.obterExcel();
    }

    enviarParametrosEventGrid()
    {
        return ParametroCupomService.enviarParametrosAoEventGrid();
    }

    render()
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelParametroCupom}
                enviarExcelParametros={ParametroCupomService.salvarExcelParametroCupom}
                deletarExcelParametros={ParametroCupomService.deletarExcelParametroCupom}
                nomeDoArquivo='Parametro Cupom'
            ></TemplateParametro>
        );
    }
}

export default ParametroCupom;